import React, { useContext, useEffect, useState } from 'react';

import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';

import QuoterContext from '../../context/QuoterContext';

import StopErrorModal from '../modals/StopErrorModal';
import Button from '../commons/Button';

import axiosInstanceWee from '../../core/api-config';
import {
  registerProgressInBackend,
  logProgressInVincoBack,
  scrollToFormStart,
} from '../../core/helper-functions';

import { FORM2_SCHEMA } from '../../constants/validation-schemas';
import {
  FORM2_SUBMIT_URL,
} from '../../constants/constants';

const Form2 = () => {
  const [isPolicyDenied, setIsPolicyDenied] = useState(false);
  const { quoterContextValues, setQuoterContextValues } = useContext(QuoterContext);
  const formInitialValues = { ...quoterContextValues.form2 };
  const formValidationSchema = Yup.object().shape(FORM2_SCHEMA);
  const browserHistory = useHistory();

  useEffect(() => {
    scrollToFormStart();
  }, []);

  const backwardsClickHandle = () => {
    setQuoterContextValues({
      ...quoterContextValues,
      ids: {
        ...quoterContextValues.ids,
        idPaso: 1,
      },
    });
    browserHistory.push('/');
  };

  const closeModalHandle = () => {
    setIsPolicyDenied(false);
  };

  const formSubmitHandle = async (values, { setFieldError }) => {
    const {
      question1,
      question2,
      question3option1,
      question3option2,
      question3option3,
      question3option4,
      question4,
    } = values;
    setQuoterContextValues({
      ...quoterContextValues,
      isAppLoading: true,
    });
    const submitValues = new URLSearchParams({
      idTramite: quoterContextValues.ids.idTramite,
      Pregunta1EnfermedadTermial: 1,
      Pregunta1Opcion: question1,
      Pregunta2Diabetes: 2,
      Pregunta2Opcion: question2,
      Pregunta3DxCondiciones: 3,
      Pregunta3Opcion1: question3option1 ? 8 : 9,
      Pregunta3Opcion2: question3option2 ? 10 : 11,
      Pregunta3Opcion3: question3option3 ? 12 : 13,
      Pregunta3Opcion4: question3option4 ? 14 : 15,
      Pregunta4Fumador: 4,
      Pregunta4Opcion: question4,
    });

    const submitFormPromise = await axiosInstanceWee.post(FORM2_SUBMIT_URL, submitValues);
    let isFormValid = false;
    const { Datos, Validacion } = submitFormPromise.data.dsRespuesta;
    let newQuoterValues = { ...quoterContextValues };

    if (Validacion) {
      Validacion.forEach((val) => {
        if (val.Detail.indexOf('Pregunta1') !== -1) {
          setFieldError('question1', 'Existe un error con este campo.');
        }
        if (val.Detail.indexOf('Pregunta2') !== -1) {
          setFieldError('question2', 'Existe un error con este campo.');
        }
        if (val.Detail.indexOf('Pregunta3') !== -1) {
          if (val.Detail.indexOf('Opcion1') !== -1) {
            setFieldError('question3option1', 'Existe un error con este campo.');
          }
          if (val.Detail.indexOf('Opcion2') !== -1) {
            setFieldError('question3option2', 'Existe un error con este campo.');
          }
          if (val.Detail.indexOf('Opcion3') !== -1) {
            setFieldError('question3option3', 'Existe un error con este campo.');
          }
          if (val.Detail.indexOf('Opcion4') !== -1) {
            setFieldError('question3option4', 'Existe un error con este campo.');
          }
        }
        if (val.Detail.indexOf('Pregunta4') !== -1) {
          setFieldError('question4', 'Existe un error con este campo.');
        }
      });
    } else if (Datos[0].idDenied) {
      setIsPolicyDenied(true);
      setQuoterContextValues({
        ...newQuoterValues,
        isAppLoading: false,
      });
      logProgressInVincoBack(
        newQuoterValues.ids.idTramite,
        new Date(),
        2,
        101,
        '001',
        submitFormPromise.status,
        submitFormPromise.status,
        null,
        submitFormPromise.data.Mensaje,
      );
    } else {
      isFormValid = true;
    }

    if (isFormValid) {
      newQuoterValues = {
        ...newQuoterValues,
        form2: values,
        isAppLoading: false,
      };

      await registerProgressInBackend(newQuoterValues.ids.idTramite, 101);
      logProgressInVincoBack(
        newQuoterValues.ids.idTramite,
        new Date(),
        1,
        101,
        '002',
        submitFormPromise.status,
        submitFormPromise.status,
        null,
        submitFormPromise.data.Mensaje,
      );
      newQuoterValues = {
        ...newQuoterValues,
        ids: {
          ...newQuoterValues.ids,
          idPaso: 3,
        },
      };
      browserHistory.push('cotizador-3');

      setQuoterContextValues(newQuoterValues);
    }
  };

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={formValidationSchema}
      onSubmit={formSubmitHandle}
      validateOnMount>
      {({ errors, touched, isSubmitting, isValid, isValidating }) => {
        return (
          <Form className="quoter-form -step-2">
            {isPolicyDenied && (
              <StopErrorModal
                onClick={closeModalHandle}
                title="Lo sentimos"
                body="No tenemos ofertas para ti." />
            )}
            <h2>Información médica</h2>
            <div className="form-fields">
              {/* QUESTION 1 */}
              <div className="field -group-checkbox">
                {errors.question1 && touched.question1 && <div className="field-invalid">{errors.question1}</div>}
                <p>¿Le han diagnosticado o tiene una enfermedad terminal?</p>
                <div className="group">
                  <label htmlFor="question1option1">
                    <Field id="question1option1" name="question1" type="radio" value="2" />
                    <div className="checkmark">
                      <span />
                    </div>
                    No
                  </label>
                  <label htmlFor="question1option2">
                    <Field id="question1option2" name="question1" type="radio" value="1" />
                    <div className="checkmark">
                      <span />
                    </div>
                    Si
                  </label>
                </div>
              </div>

              {/* QUESTION 2 */}
              <div className="field -group-checkbox">
                {errors.question2 && touched.question2 && <div className="field-invalid">{errors.question2}</div>}
                <p>¿A qué edad le diagnosticaron diabetes?</p>
                <div className="group">
                  <label htmlFor="question2option1">
                    <Field id="question2option1" name="question2" type="radio" value="3" />
                    <div className="checkmark">
                      <span />
                    </div>
                    No tengo Diabetes
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question2option2">
                    <Field id="question2option2" name="question2" type="radio" value="4" />
                    <div className="checkmark">
                      <span />
                    </div>
                    0 ~ 20 años
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question2option3">
                    <Field id="question2option3" name="question2" type="radio" value="5" />
                    <div className="checkmark">
                      <span />
                    </div>
                    21 ~ 35 años
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question2option4">
                    <Field id="question2option4" name="question2" type="radio" value="6" />
                    <div className="checkmark">
                      <span />
                    </div>
                    36 ~ 50 años
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question2option5">
                    <Field id="question2option5" name="question2" type="radio" value="7" />
                    <div className="checkmark">
                      <span />
                    </div>
                    Más de 50 años
                  </label>
                </div>
              </div>

              {/* QUESTION 3 */}
              <p>¿Le han diagnosticado alguna de las siguientes condiciones?</p>
              <div className="field -multi-binary-checkbox">
                <label htmlFor="question3option1">
                  <Field id="question3option1" name="question3option1" type="checkbox" />
                  <div className="checkmark">
                    <span />
                  </div>
                  Angina de pecho
                  {errors.question3option1 && touched.question3option1 && <div className="field-invalid">{errors.question3option1}</div>}
                </label>
                <label htmlFor="question3option2">
                  <Field id="question3option2" name="question3option2" type="checkbox" />
                  <div className="checkmark">
                    <span />
                  </div>
                  Infarto de miocardio
                  {errors.question3option2 && touched.question3option2 && <div className="field-invalid">{errors.question3option2}</div>}
                </label>
                <label htmlFor="question3option3">
                  <Field id="question3option3" name="question3option3" type="checkbox" />
                  <div className="checkmark">
                    <span />
                  </div>
                  Accidente cerebrovascular (trombosis, embolia, hemorragia cerebral,
                  aneurisma cerebral o ataque isquémico transitorio).
                  {errors.question3option3 && touched.question3option3 && <div className="field-invalid">{errors.question3option3}</div>}
                </label>
                <label htmlFor="question3option4">
                  <Field id="question3option4" name="question3option4" type="checkbox" />
                  <div className="checkmark">
                    <span />
                  </div>
                  ¿Alguna complicación grave de la diabetes (ceguera, insuficiencia
                  renal crónica, ulceras en las extremidades inferiores o amputación)?
                  {errors.question3option4 && touched.question3option4 && <div className="field-invalid">{errors.question3option4}</div>}
                </label>
              </div>

              {/* QUESTION 4 */}
              <div className="field -group-checkbox">
                {errors.question4 && touched.question4 && <div className="field-invalid">{errors.question4}</div>}
                <p>¿Cuantos cigarrillos fuma al día?</p>
                <div className="group">
                  <label htmlFor="question4option1">
                    <Field id="question4option1" name="question4" type="radio" value="16" />
                    <div className="checkmark">
                      <span />
                    </div>
                    No fumo
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question4option2">
                    <Field id="question4option2" name="question4" type="radio" value="17" />
                    <div className="checkmark">
                      <span />
                    </div>
                    1 ~ 10 cigarros
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question4option3">
                    <Field id="question4option3" name="question4" type="radio" value="18" />
                    <div className="checkmark">
                      <span />
                    </div>
                    10 ~ 20 cigarros
                  </label>
                </div>
                <div className="group">
                  <label htmlFor="question4option4">
                    <Field id="question4option4" name="question4" type="radio" value="19" />
                    <div className="checkmark">
                      <span />
                    </div>
                    Más de 20 cigarros
                  </label>
                </div>
              </div>
            </div>
            <div className="form-buttons">
              <Button
                onClick={backwardsClickHandle}
                type="button"
                label="Regresar"
                direction="backward" />
              <Button
                type="submit"
                disabled={!isValid && !isValidating && !isSubmitting}
                label="Continuar"
                direction="forward" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form2;
